import assign from 'object-assign';
import _ from 'underscore';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
import ExceptionCollection from './entities/exception-collection';
const ActionTypes = AdminConstants.ActionTypes;
const exceptionCollection = new ExceptionCollection();
let accessorialRequests = [];
let accessorialPaginatedRequests = [];
let accessorialRequestUpdates = [];
let accessorialRequestError = null;
let createException = null;
let creationError = null;
let totalPages = 0;
let totalCount = 0;
const CHANGE_EVENT = require('../constants/AdminConstants').collectionChangeEvents;
const ACCESSORIAL_REQUEST_EVENT = 'accessorial-request-change';
const ACCESSORIAL_REQUEST_PAGINATED_EVENT = 'accessorial-request-paginated-change';
const ExceptionStore = assign({}, EventEmitter.prototype, {
    getAllExceptions: function () {
        return exceptionCollection.toJSON();
    },
    getAllAccessorialRequests: function () {
        return accessorialRequests;
    },
    getShipmentAccessorialRequests: function (shipmentId) {
        const shipmentAccessorialRequests = accessorialRequests.filter((ar) => {
            var _a;
            const accessorialRequestShipmentId = ((_a = ar === null || ar === void 0 ? void 0 : ar.shipment) === null || _a === void 0 ? void 0 : _a._id) || (ar === null || ar === void 0 ? void 0 : ar.shipment);
            return accessorialRequestShipmentId === shipmentId;
        });
        return _.sortBy(shipmentAccessorialRequests, (ar) => ar.created_at);
    },
    getAllAccessorialPaginatedRequests: function () {
        return accessorialPaginatedRequests;
    },
    getAllAccessorialRequestUpdates: function () {
        return accessorialRequestUpdates;
    },
    getTotalCount: function () {
        return totalCount;
    },
    getTotalPages: function () {
        return totalPages;
    },
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addAccessorialPaginatedRequestChangeListener: function (callback) {
        this.on(ACCESSORIAL_REQUEST_PAGINATED_EVENT, callback);
    },
    removeAccessorialPaginatedRequestChangeListener: function (callback) {
        this.removeListener(ACCESSORIAL_REQUEST_PAGINATED_EVENT, callback);
    },
    addAccessorialRequestChangeListener: function (callback) {
        this.on(ACCESSORIAL_REQUEST_EVENT, callback);
    },
    removeAccessorialRequestChangeListener: function (callback) {
        this.removeListener(ACCESSORIAL_REQUEST_EVENT, callback);
    },
    emitAccessorialPaginatedRequestChange: function () {
        this.emit(ACCESSORIAL_REQUEST_PAGINATED_EVENT);
    },
    emitAccessorialRequestChange: function () {
        this.emit(ACCESSORIAL_REQUEST_EVENT);
    },
    getCreatedException: function () {
        return createException;
    },
    getCreationError: function () {
        return creationError;
    },
    onBulkCreateExceptions: function (exceptions) {
        accessorialRequests = accessorialRequests.concat(exceptions);
    },
    onCreateException: function (exception) {
        accessorialRequests = accessorialRequests.concat([exception]);
    },
    onCreationError: function (action) {
        creationError = action.err;
        createException = null;
    },
    onAccessorialRequestError: function (response) {
        accessorialRequestError = response.entity.error || response.error;
    },
    onAccessorialDocUploadFail: function (action) {
        accessorialRequestError = action.entity.error;
    },
    onUpdateException: function ({ exception: newExceptions = [] }) {
        const newIds = newExceptions.map(e => e._id);
        if (newExceptions.length) {
            const oldRequests = accessorialRequests.filter((exception) => !newIds.includes(exception._id));
            accessorialRequests = [...oldRequests, ...newExceptions];
        }
    },
    onUpdateError: function (action) {
        creationError = action.err;
        createException = null;
    },
    onReceiveExceptions: function (action) {
        var _a, _b;
        exceptionCollection.set(action.exceptions);
        totalPages = action.pages;
        totalCount = (_b = (_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0;
    },
    onReceiveAccessorialRequests: function (response) {
        accessorialRequests = response.request || [];
    },
    onReceiveAccessorialPaginatedRequests: function (response) {
        accessorialPaginatedRequests = response.result;
        accessorialRequests = response.result.items;
    },
    onReceiveAccessorialRequestsUpdates: function (updates) {
        if (updates.entity &&
            updates.entity.success === true &&
            updates.entity.results.successes.length) {
            const ids = _.map(updates.entity.results.successes, '_id');
            accessorialRequests = accessorialRequests.request.filter((exception) => !ids.includes(exception._id));
            accessorialRequests = accessorialRequests.concat(updates.entity.results.successes);
            accessorialRequestUpdates = ids;
        }
    },
    onReceiveException: function (action) {
        exceptionCollection.remove(action.exception, { merge: true });
    },
    onAccessorialDocUpload: (accessorial) => {
        accessorialRequests = accessorialRequests.filter((exception) => exception._id !== accessorial._id);
        accessorialRequests = accessorialRequests.concat(accessorial);
    },
    resolveExceptions: function (action) {
        action.exceptionIds.forEach((id) => {
            exceptionCollection.remove(id, { silent: true });
        });
    },
    resolveException: function (action) {
        exceptionCollection.remove(action.exceptionId, { silent: true });
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    updateException: function (exception) {
        const keys = [
            'shipment',
            'stop',
            'carrier',
            'driver',
            'shipper',
            'description',
        ];
        const currentException = exceptionCollection.get(exception._id);
        if (currentException) {
            const populatedFields = _.pick(currentException.attributes, keys);
            exceptionCollection.remove(exception._id, { silent: true });
            const updatedException = Object.assign(Object.assign({}, exception), populatedFields);
            exceptionCollection.add(updatedException);
        }
    },
});
ExceptionStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVE_EXCEPTIONS:
            ExceptionStore.onReceiveExceptions(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.RECEIVE_EXCEPTION:
            ExceptionStore.onReceiveException(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.RECEIVE_CREATE_EXCEPTION:
            ExceptionStore.onCreateException(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.RESOLVE_EXCEPTION:
            ExceptionStore.resolveException(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.RESOLVE_EXCEPTIONS:
            ExceptionStore.resolveExceptions(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.APPROVE_ACCESSORIALS_SUCCESS:
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialRequestChange();
            break;
        case ActionTypes.DECLINE_ACCESSORIALS_SUCCESS:
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialRequestChange();
            break;
        case ActionTypes.ACCEPT_ACCESSORIALS_SUCCESS:
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialRequestChange();
            break;
        case ActionTypes.RECEIVE_ACCESSORIAL_REQUEST_SUCCESS:
            ExceptionStore.onReceiveAccessorialRequests(action.response);
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialRequestChange();
            break;
        case ActionTypes.RECEIVE_ACCESSORIAL_PAGINATED_REQUEST_SUCCESS:
            ExceptionStore.onReceiveAccessorialPaginatedRequests(action.response);
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialPaginatedRequestChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIAL_REQUEST_SUCCESS:
            ExceptionStore.onReceiveAccessorialRequestsUpdates(action.response);
            ExceptionStore.emitAccessorialRequestChange();
            ExceptionStore.emitChange();
            break;
        case ActionTypes.UPLOAD_ACCESSORIAL_DOC_SUCCESS:
            ExceptionStore.onAccessorialDocUpload(action.response);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.UPLOAD_ACCESSORIAL_DOC_FAIL:
            ExceptionStore.onAccessorialDocUploadFail(action.response);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIAL_REQUEST_FAIL:
            ExceptionStore.onAccessorialRequestError(action.response);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.UPDATE_EXCEPTION:
            ExceptionStore.updateException(action.result.exception);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.BULK_CREATE_ACCESSORIAL_REQUEST_SUCCESS:
            ExceptionStore.onBulkCreateExceptions(action.result.successes);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.CREATE_ACCESSORIAL_REQUEST_SUCCESS:
            ExceptionStore.onCreateException(action.exception);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.CREATE_ACCESSORIAL_REQUEST_FAIL:
            ExceptionStore.onCreationError(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.RECEIVE_ACCESSORIAL_REQUEST_FAIL:
            ExceptionStore.onAccessorialRequestError(action.response);
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialRequestChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIAL_EXCEPTION_SUCCESS:
            ExceptionStore.onUpdateException(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIAL_EXCEPTION_FAIL:
            ExceptionStore.onUpdateError(action);
            ExceptionStore.emitChange();
            break;
        case ActionTypes.APPROVE_ACCESSORIALS_FAIL:
            // Emit change to notify components that approval failed
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialRequestChange();
            break;
        case ActionTypes.DECLINE_ACCESSORIALS_FAIL:
            // Emit change to notify components that decline failed
            ExceptionStore.emitChange();
            ExceptionStore.emitAccessorialRequestChange();
            break;
        default:
            break;
    }
});
export default ExceptionStore;
